/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import 'prismjs/themes/prism-tomorrow.css'
//https://github.com/PrismJS/prism/tree/1d5047df37aacc900f8270b1c6215028f6988eb1/themes

import { AppProvider } from './src/pages'
export const wrapRootElement = ({ element }) => {
  return <AppProvider>{element}</AppProvider>
}
